import { Member } from "../../../types/employee.types";
import { CoverageCode, EnrollmentStandardDetails, VEBEnrollmentStandardDetails } from "../../../types/enrollment.types";

export const getCoveredDependents = (
	coverage: string,
	eligibleDependents: Member[]
): {
	enrollmentStandardDetails: EnrollmentStandardDetails[];
	dep_SSNs: string[];
} => {
	const enrollmentStandardDetails: EnrollmentStandardDetails[] = [];
	const dep_SSNs: string[] = [];

	if (coverage === "Employee & Spouse") {
		// console.log("coverage1", coverage);
		// console.log("coverage3", eligibleDependents);
		eligibleDependents.forEach((eligibleDependent: Member) => {
			// console.log("eligibleDependent", eligibleDependent);
			const { _id, SSN, relationship } = eligibleDependent;
			if (relationship === "SPOUSE") {
				enrollmentStandardDetails.push({
					member_object_id: _id,
					member_SSN: SSN,
					premium_amount: 0,
					coverage_code: "Employee & Spouse"
				});
				dep_SSNs.push(SSN);
			}
		});
	} else if (coverage === "Employee & Dependents") {
		eligibleDependents.map((eligibleDependent: Member) => {
			const { _id, SSN, relationship } = eligibleDependent;
			if (relationship !== "SPOUSE") {
				enrollmentStandardDetails.push({
					member_object_id: _id,
					member_SSN: SSN,
					premium_amount: 0,
					coverage_code: "Employee & Dependents"
				});
				dep_SSNs.push(SSN);
			}
		});
	} else if (coverage === "Employee & Family") {
		eligibleDependents.map((eligibleDependent: Member) => {
			const { _id, SSN } = eligibleDependent;
			// console.log("asdas", enrollmentStandardDetails);
			enrollmentStandardDetails.push({
				member_object_id: _id,
				member_SSN: SSN,
				premium_amount: 0,
				coverage_code: "Employee & Family"
			});
			dep_SSNs.push(SSN);
		});
	}
	return {
		enrollmentStandardDetails,
		dep_SSNs
	};
};

export const getHealthInsuranceCoveredDependents = (
	coverageCode: CoverageCode | string,
	benefitAmount: number,
	eligibleDependents: Member[]
): VEBEnrollmentStandardDetails[] => {
	const enrollmentStandardDetails: VEBEnrollmentStandardDetails[] = [];
	// console.log("eligibleDependents", eligibleDependents);
	if (coverageCode === "ES") {
		// console.log("coverage1", coverageCode);
		// console.log("coverage3", eligibleDependents);
		eligibleDependents.forEach((eligibleDependent: Member) => {
			// console.log("eligibleDependent", eligibleDependent);
			const { _id, SSN, relationship } = eligibleDependent;
			if (relationship === "SPOUSE") {
				enrollmentStandardDetails.push({
					member_object_id: eligibleDependent._id,
					member_SSN: eligibleDependent.SSN,
					premium_amount: 0,
					coverage_code: coverageCode,
					benefit_amount: benefitAmount,
					is_tobacco: eligibleDependent.is_tobacco
				});
			}
		});
	} else if (coverageCode === "ED") {
		eligibleDependents.map((eligibleDependent: Member) => {
			const { _id, SSN, relationship } = eligibleDependent;
			if (relationship !== "SPOUSE") {
				enrollmentStandardDetails.push({
					member_object_id: eligibleDependent._id,
					member_SSN: eligibleDependent.SSN,
					premium_amount: 0,
					coverage_code: coverageCode,
					benefit_amount: benefitAmount,
					is_tobacco: eligibleDependent.is_tobacco
				});
			}
		});
	} else if (coverageCode === "ECH") {
		eligibleDependents.map((eligibleDependent: Member) => {
			const { relationship } = eligibleDependent;
			const ECHRelationship = ["SON", "CHILD", "DAUGHTER", "STEP CHILD"];
			if (relationship !== null && ECHRelationship.includes(relationship)) {
				enrollmentStandardDetails.push({
					member_object_id: eligibleDependent._id,
					member_SSN: eligibleDependent.SSN,
					premium_amount: 0,
					coverage_code: coverageCode,
					benefit_amount: benefitAmount,
					is_tobacco: eligibleDependent.is_tobacco
				});
			}
		});
	} else if (coverageCode === "EF") {
		eligibleDependents.map((eligibleDependent: Member) => {
			const { _id, SSN } = eligibleDependent;
			// console.log("asdas", enrollmentStandardDetails);
			enrollmentStandardDetails.push({
				member_object_id: eligibleDependent._id,
				member_SSN: eligibleDependent.SSN,
				premium_amount: 0,
				coverage_code: coverageCode,
				benefit_amount: benefitAmount,
				is_tobacco: eligibleDependent.is_tobacco
			});
		});
	}
	return enrollmentStandardDetails;
};

export const getKemperCancerCoveredDependents = getHealthInsuranceCoveredDependents;
